import { Layout } from '~/layouts';
import Image from 'next/image';
import { Animate, Button } from '~/components';
import { Icon } from '@iconify/react';

const workExperience = [
	{
		company: 'Convert Lead',
		title: 'Backend Developer',
		duration: '2020 - 2021',
	},
	{
		company: 'Craft Music',
		title: 'Solution Architect',
		duration: '2019 - 2020',
	},
	{
		company: 'Fitdog',
		title: 'AWS Architect Developer',
		duration: '2018 - 2019',
	},
	{
		company: 'Thiken',
		title: 'Backend Developer',
		duration: '2017 - 2018',
	},
];

const majorSkills = [
	'AWS ECS, Beanstalk, Aurora, Cognito, ElasticSearch, Lambda, AppEngine, S3',
	'CDK, SAM, Terraform, Serverless Framework, Cloudformation',
	'Python, Typescript, Golang',
	'Django, Flask, FastApi, Node.js, Nest.js, Express.js',
	'React.js, Svelte, Vue.js',
	'PostgreSQL, MongoDB, DynamoDB',
];

export default function AboutMe() {
	return (
		<Layout.Default seo={{ title: 'roberto - about-me' }}>
			<div className="mx-2 my-24 sm:mx-6 lg:mb-28 lg:mx-8">
				<div className="relative max-w-3xl mx-auto bg-opacity-75 rounded-lg bg-gray-50 dark:bg-gray-900 dark:bg-opacity-75 backdrop-filter backdrop-blur-sm dark:text-gray-200">
					<h1>
						<span className="block text-base font-semibold tracking-wide text-center text-teal-500 uppercase dark:text-teal-400">
							About me
						</span>
						<span className="block max-w-2xl mx-auto mt-2 text-4xl font-bold leading-10 text-center sm:text-5xl dark:text-white">
							Here&apos;s my story.
						</span>
					</h1>
					<div className="grid grid-cols-1 gap-0 mt-8 md:grid-cols-4 md:gap-x-5">
						<div className="col-span-1">
							<Image
								className="rounded-xl group-hover:opacity-75"
								objectFit="fill"
								src="/roberto.png"
								width={320}
								height={320}
								layout="responsive"
								alt={'article cover'}
							/>
						</div>
						<div className="col-span-3">
							<p className="text-lg dark:text-gray-200">
								Hi. I&apos;m Roberto Olayvar, a full-stack software engineer, and
								solution architect who specializes in Backend Development and
								DevOps. My mission is to translate business logic into backoffices
								and rest apis, and to deploy them to the server that runs blazing
								fast.
							</p>
							<p className="mt-4 text-lg dark:text-gray-200">
								You can find me on{' '}
								<a
									href={'https://github.com/roberto2321'}
									className="text-blue-600 visited:text-purple-600 font-medium">
									GitHub
								</a>
								.
							</p>
						</div>
					</div>
					<p className="text-lg">
						As a full-stack solution architect, I have many experience working with
						small to large teams, leading, managing, and helping others.
					</p>
					<div className="mt-4 text-lg dark:text-gray-200">
						<p className="font-semibold">Major skills:</p>
						<ul className="list-none">
							{majorSkills.map((skill, index) => (
								<li key={`${index}`} className="flex items-center">
									<Icon
										aria-hidden="true"
										className="mr-3 text-md text-emerald-500"
										icon="fe:check-circle"
									/>
									{skill}
								</li>
							))}
						</ul>
					</div>
					<p className="mt-4 text-lg">
						Infrastructure setup on AWS and test-driven-CICD flow is my main working
						style. For me, to make the best solutions for the given project is the first
						and most important goal in work. It means to choose time-proven,
						top-notched, scalable but simple solutions among available solutions, based
						on the requirements and the IT tendency.
					</p>

					<p className="mt-4 text-lg">
						Contact me today, and let’s speed up your success!
					</p>

					<hr className="my-4 w-full border-none text-center h-10 before:content-['∿∿∿'] before:text-[#D1D5DB] before:text-2xl"></hr>
					<div className="mt-12 space-y-6">
						<h2 className="m-0 text-2xl text-gray-900 dark:text-white font-semibold">
							Work experience
						</h2>
						<p className="text-lg">
							Here&apos;s a brief rundown of my most recent experiences.
						</p>
						<div className="space-y-2">
							{workExperience.map((workItem) => (
								<div
									key={workItem.company}
									className="flex items-center space-x-3 group">
									<span className="flex-none text-gray-900 gover-hover:underline dark:text-white">
										{workItem.company}
									</span>
									<span className="w-full border-t border-gray-300 border-dashed shrink dark:border-gray-700"></span>
									<span className="flex-none dark:text-gray-200">
										{workItem.title}
									</span>
									<span className="flex-none dark:text-gray-200">
										{workItem.duration}
									</span>
								</div>
							))}
						</div>
						<div className="inline-flex w-full md:w-auto ">
							<Animate
								animation={{
									y: [50, 0],
									opacity: [0, 1],
								}}
								className="w-full sm:w-auto"
								transition={{
									delay: 0.1 * 2 + 0.5,
								}}>
								<Button.Outline
									href={process.env.RESUME_URL ?? '#'}
									target="_blank">
									<span>View my resume</span>
									<Icon
										aria-hidden="true"
										className="ml-3"
										icon="feather:external-link"
									/>
								</Button.Outline>
							</Animate>
						</div>
					</div>
					<hr className="my-16 w-full border-none text-center h-10 before:content-['∿∿∿'] before:text-[#D1D5DB] before:text-2xl"></hr>
				</div>
			</div>
		</Layout.Default>
	);
}
